import React from 'react'
import styled from 'styled-components'
import date_selection_action_btn_wrapperStyles from './date_selection_action_btn_wrapper.styles'

const apAtomName = {ap_atom_name: 'apDateSelectionActionBtnWrapperAtom'}

const StyledWrapper = styled(props => <div {...props} />)`
  ${date_selection_action_btn_wrapperStyles}
`

const DateSelectionActionBtnWrapperAtom: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = function (props) {
  return <StyledWrapper {...apAtomName} {...props} />
}

export default DateSelectionActionBtnWrapperAtom
